export default "__VITE_ASSET__BLAojYTf__"